module.exports = __webpack_public_path__ + "img/home.f6f7af99.svg";